import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem("adminToken", res.data.token);
      toast.success(`Welcome back, ${res.data.username}`);
      navigate("/admin");
    } catch {
      toast.error("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <button
          data-testid="back-to-portal-link"
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-[10px] text-[#A8A29E] hover:text-[#1C1917] transition-colors mb-10 tracking-widest uppercase font-manrope"
        >
          <ArrowLeft size={13} />
          Back to portal
        </button>

        <p className="text-[10px] tracking-[0.3em] uppercase text-[#A8A29E] mb-2 font-manrope">
          Admin Access
        </p>
        <h1 className="text-4xl font-playfair text-[#1C1917] mb-8 tracking-tight">Sign In</h1>

        <form onSubmit={handleLogin} className="space-y-7">
          <div>
            <label className="block text-[10px] tracking-widest uppercase text-[#A8A29E] mb-2 font-manrope">
              Username
            </label>
            <input
              data-testid="admin-username-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
              autoComplete="username"
              className="w-full bg-transparent border-b border-[#E7E5E4] py-3 text-base text-[#1C1917] placeholder-[#C8C4C0] focus:outline-none focus:border-[#D4AF37] transition-colors duration-200 font-manrope"
            />
          </div>

          <div>
            <label className="block text-[10px] tracking-widest uppercase text-[#A8A29E] mb-2 font-manrope">
              Password
            </label>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              autoComplete="current-password"
              className="w-full bg-transparent border-b border-[#E7E5E4] py-3 text-base text-[#1C1917] placeholder-[#C8C4C0] focus:outline-none focus:border-[#D4AF37] transition-colors duration-200 font-manrope"
            />
          </div>

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full h-14 bg-[#1C1917] text-[#D4AF37] text-[10px] tracking-[0.2em] uppercase font-semibold font-manrope hover:bg-[#292524] transition-colors duration-300 rounded-sm active:scale-[0.99] disabled:opacity-60"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <Loader2 className="animate-spin" size={16} />
                Signing in…
              </span>
            ) : (
              "Sign In"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
